"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var PropTypes = require("prop-types");
var classnames_1 = require("classnames");
var utils_1 = require("../utils");
var styleFactory = function (top, style) { return (tslib_1.__assign({}, style, { marginTop: utils_1.toREMString(top) })); };
var PageContainer = /** @class */ (function (_super) {
    tslib_1.__extends(PageContainer, _super);
    function PageContainer(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.state = { windowInnerWidth: window.innerWidth };
        _this.onWindowResize = utils_1.debounce(_this.onWindowResize, 250).bind(_this);
        _this.onBeforeUnload = _this.onBeforeUnload.bind(_this);
        _this.initialize();
        return _this;
    }
    PageContainer.prototype.setBeforeUnloadWarning = function () {
        window.addEventListener("beforeunload", this.onBeforeUnload);
    };
    PageContainer.prototype.unsetBeforeUnloadWarning = function () {
        window.removeEventListener("beforeunload", this.onBeforeUnload);
    };
    PageContainer.prototype.onBeforeUnload = function (e) {
        var beforeUnloadWarning = this.props.beforeUnloadWarning;
        e.returnValue = beforeUnloadWarning;
        return beforeUnloadWarning;
    };
    PageContainer.prototype.componentDidUpdate = function (prevProps, prevState) {
        if (prevState.windowInnerWidth !== this.state.windowInnerWidth) {
            utils_1.raf(function () {
                utils_1.triggerUIEvent(window, "resize");
            });
        }
    };
    PageContainer.prototype.initialize = function () {
        var pageTitle = this.props.pageTitle;
        this.setPageTitle(pageTitle);
    };
    PageContainer.prototype.componentDidMount = function () {
        window.addEventListener("resize", this.onWindowResize, false);
        if (this.props.beforeUnloadWarning) {
            this.setBeforeUnloadWarning();
        }
    };
    PageContainer.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
        if (nextProps.pageTitle !== this.props.pageTitle) {
            this.setPageTitle(nextProps.pageTitle);
        }
        if (nextProps.beforeUnloadWarning !== this.props.beforeUnloadWarning) {
            this.unsetBeforeUnloadWarning();
            if (nextProps.beforeUnloadWarning) {
                this.setBeforeUnloadWarning();
            }
        }
    };
    PageContainer.prototype.componentWillUnmount = function () {
        this.context.unsetAppTitle();
        window.removeEventListener("resize", this.onWindowResize, false);
        this.unsetBeforeUnloadWarning();
    };
    PageContainer.prototype.onWindowResize = function () {
        this.setState({
            windowInnerWidth: window.innerWidth
        });
    };
    PageContainer.prototype.setPageTitle = function (title) {
        var _this = this;
        setTimeout(function () { return _this.context.setAppTitle(title); });
    };
    PageContainer.prototype.render = function () {
        var _a;
        var _b = this.props, children = _b.children, theme = _b.theme, className = _b.className, pageTitle = _b.pageTitle, inner = _b.inner, strict = _b.strict, minWindowWidthForInnerPage = _b.minWindowWidthForInnerPage, top = _b.top, style = _b.style, beforeUnloadWarning = _b.beforeUnloadWarning, others = tslib_1.__rest(_b, ["children", "theme", "className", "pageTitle", "inner", "strict", "minWindowWidthForInnerPage", "top", "style", "beforeUnloadWarning"]);
        var windowInnerWidth = this.state.windowInnerWidth;
        var classes = classnames_1.default(theme.container, className, (_a = {},
            _a[theme.inner] = inner && (!strict ? windowInnerWidth > minWindowWidthForInnerPage : true),
            _a));
        return (React.createElement("div", tslib_1.__assign({}, others, { className: classes, style: styleFactory(top, style) }), children));
    };
    PageContainer.defaultProps = {
        minWindowWidthForInnerPage: 1680
    };
    PageContainer.contextTypes = {
        setAppTitle: PropTypes.func,
        unsetAppTitle: PropTypes.func
    };
    return PageContainer;
}(React.Component));
exports.default = PageContainer;
